import { render, staticRenderFns } from "./CollectionDescription.vue?vue&type=template&id=73316e7a&scoped=true"
import script from "./CollectionDescription.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectionDescription.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CollectionDescription.vue?vue&type=style&index=0&id=73316e7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73316e7a",
  null
  
)

export default component.exports